import Alpine from "alpinejs";

Alpine.data("video", () => {
  return {
    // State
    isPlaying: false,

    // State Modifiers
    handlePlay() {
      this.isPlaying = true;
    },
    handlePause() {
      this.isPlaying = false;
    },
    handleToggle() {
      if (this.isPlaying) this.handlePause();
      else this.handlePlay();
    },

    // Lifecycle Hooks
    init() {
      Alpine.bind(this.$root, this.root);
    },

    // Bound Directives
    root: {
      [":data-ui"]() {
        if (this.isPlaying) return "playing";
        else return "paused";
      },
    },
    play: {
      ["@click"]() {
        this.handlePlay();
      },
    },
    pause: {
      ["@click"]() {
        this.handlePause();
      },
    },
    toggle: {
      ["@click"]() {
        this.handleToggle();
      },
    },
    source: {
      ["x-ref"]: "source",
      ["x-init"]() {
        const video = this.$refs.source as HTMLVideoElement;
        if (video.autoplay) this.isPlaying = true;
      },
      ["x-effect"]() {
        const video = this.$refs.source as HTMLVideoElement;
        if (this.isPlaying) video.play();
        else video.pause();
      },
    },
  };
});
